import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NetworkInterface } from '@ionic-native/network-interface/ngx';
import { NavController } from '@ionic/angular';
import { apiRequest } from 'src/environments/environment';
import { SessionService } from './../session/session.service';
import { Storage } from '@ionic/storage';
import { SharedDataService } from '../shared_data.service';
import { using } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RedeService {
  private QUANTIDADE_MAX_TENTATIVA = 1;
  // private TIMEOUT: number = 15000;

  public isIntranetCadoma: boolean = false;

  //ionic cordova plugin add cordova-plugin-networkinterface

  constructor(
    public http: HttpClient,
    private networkInterface: NetworkInterface,
    public sessionService: SessionService,
    private navController: NavController,
    private storage: Storage,
    public sharedDataService: SharedDataService
  ) {

  }

  async getInstacia() {
    var instacia: string = await this.storage.get("instancia");
    return instacia;
  }

  async getBaseUrl() {
    var instacia: string = await this.storage.get("instancia");

    if (this.isIntranetCadoma) {
      return apiRequest.url_rasp + "/api/";
    } else {
      if (instacia == null || instacia.length == 0) {
        //FAM
        // instacia = "5656";
        //Fisher
        // instacia = "5467";
        //instacia = "8080";
        //Localhost
         instacia = "3541";
      }
      return apiRequest.url + ":" + instacia + "/api/";
    }
  }

  async getSafeIpAddress() {
    try {
      return this.getIpAddress();
    }catch(e){
      return 'unknown';
    }
  }

  async getIpAddress() {
    try {
      // Tenta pegar IP do cordova
      let wifi_ip = await this.networkInterface.getWiFiIPAddress();
      return wifi_ip.ip;
    } catch (e1) {
      // Pega IP usando API publica
      try {
        const response = await fetch('https://api.ipify.org?format=json');
        const data = await response.json();
        return data.ip;
      } catch (e2) {
        // Pega IP local
        try {
          const local_ip = await this.getLocalIP();
          return local_ip;  
        } catch (e3) {
          console.error('Failed to retrieve IP address:', e1, e2, e3);
          throw new Error('Unable to retrieve IP address');
        }
      }
    }
  }

  async getLocalIP() {
    return new Promise((resolve, reject) => {
      const peerConnection = new RTCPeerConnection({ iceServers: [] });
      peerConnection.createDataChannel("");
      peerConnection.createOffer().then(offer => peerConnection.setLocalDescription(offer));
      
      peerConnection.onicecandidate = (event) => {
        if (event.candidate) {
          const candidate = event.candidate.candidate;
          const match = candidate.match(/(?:\d{1,3}\.){3}\d{1,3}/);
          if (match) {
            resolve(match[0]);
          }
        }
      };
      setTimeout(() => reject(new Error("Failed to get local IP")), 5000);
    });
  }

  async getMobileAppIpAddress() {
    try {
      let a= await this.networkInterface.getWiFiIPAddress();
      return a.ip;
    } catch (e){
      return '';
    }
  }

  verificaConexao(): Promise<string> {
    if (!this.sharedDataService.isApp){ 
      this.isIntranetCadoma = false;
      return this.getBaseUrl();
    }
    return new Promise((accept, reject) => {
      this.networkInterface.getWiFiIPAddress()
        .then(address => {
          this.isIntranetCadoma = address.ip.includes("10.10.10");
          accept(this.getBaseUrl())

        }).catch(error => {
          // console.error(`Unable to get IP: ${error}`)
          this.isIntranetCadoma = false;
          accept(this.getBaseUrl());
        }
        );
    });
  }

  async get<T>(url: String, tentativa: number = 0): Promise<T> {
    console.log("GET : url = " + url)

    let urlBase = await this.verificaConexao();
    let httpOptions = {}
    if (this.sessionService.session) {
      httpOptions = {
        headers: new HttpHeaders({ 'Authorization': this.sessionService.session.token }),
      }
    }

    try {
      return await this.http.get<T>(urlBase + url, httpOptions).toPromise();
    } catch (error) {

      let renovouToken = await this.verificaErroTokenDesatualizado(error);
      if (renovouToken) {
        return await this.get<T>(url, tentativa);
      } else {
        tentativa++;

        if (tentativa < this.QUANTIDADE_MAX_TENTATIVA) {
          return await this.get<T>(url, tentativa);
        } else {
          throw error;
        }
      }

    }

  }

  async downloadPut(url: string, body: any, fileName: string) {
    let urlBase = await this.verificaConexao();
    let httpOptions = {}
    if (this.sessionService.session) {
      httpOptions = {
        headers: new HttpHeaders({ 'Authorization': this.sessionService.session.token }),
        responseType: 'blob'
      }
    }

    this.http.put(urlBase + url, body, httpOptions)
      .subscribe(blob => {
        const a = document.createElement('a')
        const objectUrl = URL.createObjectURL(blob)
        a.href = objectUrl
        a.download = fileName;
        a.click();
        URL.revokeObjectURL(objectUrl);
      })
  }

  async put<T>(url: String, body: any, tentativa: number = 0): Promise<T> {
    console.log("PUT : url = " + url)

    let urlBase = await this.verificaConexao();

    let httpOptions = {
      headers: new HttpHeaders({ 'Authorization': this.sessionService.session.token }),
      // withCredentials:false
    }

    try {
      return await this.http.put<T>(urlBase + url, body, httpOptions).toPromise();
    } catch (error) {

      let renovouToken = await this.verificaErroTokenDesatualizado(error);
      if (renovouToken) {
        return await this.put<T>(url, body, tentativa);
      } else {
        tentativa++;

        if (tentativa < this.QUANTIDADE_MAX_TENTATIVA) {
          return await this.put<T>(url, body, tentativa);
        } else {
          throw error;
        }
      }

    }

  }

  async verificaErroTokenDesatualizado(error) {

    if (error.status == 401) {
      //TODO Renovar a session.
      if (this.sessionService.session) {
        // buscar novo token no servidor/
        await this.renovarToken();
        return true;
      } else {
        this.navController.navigateRoot('/login');
      }
    }

    return false;
  }


  async renovarToken() {
    console.log("renovarToken")

    let user = {
      username: this.sessionService.session.email,
      password: this.sessionService.session.senha
    }
    let urlBase = await this.verificaConexao();


    try {
      let jwt: any = await this.http.post(urlBase + "authenticate", user).toPromise()


      if (jwt) {
        this.sessionService.atualizarToken(jwt.token)
      } else {
        //Usuário mudou de senha, ou foi desativado.
        await this.sessionService.logout();
        throw new TypeError("Usuário ou senha inválidos");
      }

    } catch (error) {
      console.log("Erro do servidor ", error)

      if (error instanceof HttpErrorResponse && error.status == 401) {
        //Usuário mudou de senha, ou foi desativado.
        await this.sessionService.logout();
        throw new TypeError("Usuário ou senha inválidos");
      }

      throw error;
    }

  }

  async cliente() {
    try {
      let burl = await this.getBaseUrl();
      console.log("Trying to `verificaConexao` at ", burl, "...");
      let urlBase = await this.verificaConexao();
      console.log("Trying to `verificaConexao` at ", urlBase, "...");
      let aa: any = await this.http.get(urlBase + "cliente").toPromise();
      return aa.nome;
    } catch (erro) {
      console.error("Erro ao buscar cliente ", erro)
    }
    return "ERRO"
  }

  async testarCliente( porta:string) {
    let urlBase = "";
    if (this.isIntranetCadoma) {
      urlBase = apiRequest.url_rasp + "/api/";
    } else {
   
      urlBase = apiRequest.url + ":" + porta + "/api/";
    }

    let aa: any = await this.http.get(urlBase + "cliente").toPromise();
    return aa.nome;
  }

  async login(instancia: string, email: string, password: string) {
    let user = {
      username: email,
      password: password
    }

    await this.storage.set("instancia", instancia);
    let urlBase = await this.verificaConexao();
    console.log("urlBase", urlBase)
    let jwt:any;

    try {
      jwt = await this.http.post(urlBase + "authenticate", user).toPromise();

      //Usuário ou senha válido.
      if (jwt) {
        //Depois que logou com sucesso, prepara para salvar a sessão.
        let httpOptions = {
          headers: new HttpHeaders({ 'Authorization': jwt.token }),
          withCredentials: false
        }
        let userSession: any = await this.http.get(urlBase + "session", httpOptions).toPromise();
        await this.sessionService.createSession(email, password, userSession.nome, jwt.token, userSession.baseUrl, userSession.autorizacoes);
      }
    } catch (error) {
      console.error("Erro do servidor ", error)

      if (error instanceof HttpErrorResponse) {
        if (error.status === 0) {
          throw new TypeError("Sem conexão com o servidor ! \n " + urlBase);
        }
        throw new TypeError("Erro desconhecido " + error.statusText);
      }
      
      throw new TypeError("Erro desconhecido " + error);
    }

    if (!jwt) {
      throw new TypeError("Usuário ou senha inválidos");
    }

  }

  async recuperarSenha(username: string) {

    let urlBase = await this.verificaConexao();
    console.log("urlBase", urlBase)

    try {
      await this.http.post(urlBase + "recuperarSenha", username).toPromise();
      // console.log("jwt.token", jwt.token)
    } catch (error) {
      console.log("Erro do servidor ", error)

      if (error instanceof HttpErrorResponse && error.status == 401) {
        throw new TypeError("Usuário ou senha inválidos");
      }
      throw new TypeError("Servidor sem conexão !");
    }

  }

  async salvarSenha(password: String, token:string) {
    let novaSenhaBean = {
      password: password,
      token: token
    }
    console.log(novaSenhaBean)
    let urlBase = await this.verificaConexao();
    console.log("urlBase", urlBase)

    try {
      await this.http.post(urlBase + "salvarSenha", novaSenhaBean).toPromise();
      console.log(novaSenhaBean)
    } catch (error) {
      console.log("Erro do servidor ", error)
      console.log(novaSenhaBean)
      if (error instanceof HttpErrorResponse && error.status == 401) {
        throw new TypeError("Usuário ou senha inválidos");
      }
      throw new TypeError("Servidor sem conexão !");
    }
  }

}
